import React from 'react';

const Footer = () => {
  return (
    <footer>
      <span className="footer-copy-right">
        Copyright &copy; BROADBAND TOWER, INC. ALL RIGHTS RESERVED.
      </span>
      <a target="_blank" className="footer-link" href="https://www.bbtower.co.jp/corporate/">
        会社情報
      </a>
      <span>|</span>
      <a target="_blank" className="footer-link" href="https://www.bois.bbtower.co.jp/docs/bois_agreement.pdf">
        ご利用条件
      </a>
    </footer>
  );
};

export default Footer;
